import classNames from 'classnames'
import React from 'react'
import {Animated} from '../../../../../../../commons/components/animated'
import {FullDateLocation} from '../../../full-date-location'
import {Ribbon} from '../../../ribbon'
import {RsvpButton} from '../../../rsvp-button'
import {Image} from '../../common/image'
import {isMobile, isSite} from '../../../../../../../commons/selectors/environment'
import {useWidgetState} from '../../../../hooks/state-provider'
import {isItemOpened} from '../../../../selectors/layout'
import {getRibbonData} from '../../../../selectors/events'
import {getComponentConfig, isListLayout, isMembersVisible} from '../../../../selectors/settings'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import {AdditionalInfoToggle} from './additional-info-toggle'
import {Title} from './title'
import {Share} from './share'
import {Members} from './members'
import {Description} from './description'
import {Date} from './date'
import s from './cards-mobile-item.scss'

export const CardsMobileItem = ({event, hovered}: {event: ExtendedEvent; hovered: boolean}) => {
  const {
    allBreakpoints: {isListImageEnabled},
  } = useVisibilityStyles()
  const imageVisible = isListImageEnabled()
  const opened = useWidgetState(state => isItemOpened(state, event.id))
  const mobile = useWidgetState(isMobile)
  const showMembers = useWidgetState(state => isMembersVisible(state, event))
  const listLayout = useWidgetState(state => isListLayout(getComponentConfig(state)))
  const showRibbon = useWidgetState(state => getRibbonData(state, event).visible)
  const animates = useWidgetState(isSite)

  return (
    <>
      {imageVisible ? (
        <div className={s.image}>
          <Image event={event} />
        </div>
      ) : null}
      {showRibbon ? <Ribbon event={event} className={s.ribbon} /> : null}
      <Date event={event} />
      <Title event={event} />
      <AdditionalInfoToggle opened={opened} active={!mobile && (hovered || opened)} />
      <div className={s.additionalInfoContainer}>
        <Animated disabled={!animates} show={opened} height={calculateContentHeight}>
          <div className={classNames(s.additionalInfo, listLayout ? s.listContentText : s.mobileCardsContentText)}>
            <FullDateLocation event={event} />
            {showMembers ? <Members event={event} /> : null}
            <Description event={event} />
            <Share event={event} />
          </div>
        </Animated>
      </div>
      <div className={s.buttonContainer}>
        <RsvpButton event={event} fullWidth={mobile} className={s.buttonFont} />
      </div>
    </>
  )
}

const calculateContentHeight = (element: HTMLElement) => element.offsetHeight + 60
